import { Outlet } from 'react-router-dom';
import PageShell from '@/components/PageShell';

/**
 * Site header + footer around the long-form /resources/* guides.
 *
 * The guides used to render as a bare <div> with no navigation at all: a reader
 * landing from search saw the article and a "Back to Resources" link, and no way
 * to reach the homepage, pricing or signup without editing the URL. HomeHeader is
 * `fixed`, so the outlet is padded down to clear it.
 */
export default function ArticleChrome() {
  return (
    <PageShell headerTransparent={false}>
      <div className="pt-16 md:pt-20">
        <Outlet />
      </div>
    </PageShell>
  );
}
